import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio';
import { MatTooltip } from '@angular/material/tooltip';
import { StartCasePipe } from '@ng-cloud/badger-core/common/pipes/start-case.pipe';
import { LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { Map } from '../../models/map';
import { MapComponent } from '../map.component';

@Component({
  selector: 'bt-map-select-controls',
  templateUrl: './map-select-controls.component.html',
  styleUrls: ['./map-select-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LayoutDirective,
    MatCard,
    MatIcon,
    MatIconButton,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatRadioButton,
    MatRadioGroup,
    MatTooltip,
    StartCasePipe
  ]
})
export class MapSelectControlsComponent implements OnInit {
  @Input() mapComponent: MapComponent;
  @Input() maps: Map[] = [];

  selectedMap: Map;

  @Output() change: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.selectedMap = this.maps.find((map) => map.mapType == 'low');
  }

  changeMap(map) {
    this.selectedMap = map;
    this.mapComponent.setMap(map);
    this.change.emit(map);
  }
}
